// src/scripts/utilities/logger.js
function Logger(baseDebugMessage, debugMessage = null) {
  const logLevels = ["debug", "error", "info", "log", "warn"];
  logLevels.forEach((key) => {
    if (debugMessage === false) {
      this[key] = () => {
      };
    } else {
      this[key] = console[key].bind(null, baseDebugMessage);
    }
  });
  return this;
}
var logger_default = Logger;

// src/scripts/utilities/cylindo.js
var logger = new logger_default("Cylindo:");
var cachedConfig;
var validOptions = null;
function cylindoConfig() {
  if (cachedConfig !== void 0) return cachedConfig;
  const el = document.querySelector("[data-cylindo-config]");
  try {
    cachedConfig = el ? JSON.parse(el.textContent) : null;
  } catch (err) {
    logger.error("Failed to parse config", err);
    cachedConfig = null;
  }
  return cachedConfig;
}
var isLikelyVariantId = (value) => /^\d{10,}$/.test(String(value));
function cylindoFeatureCode(key) {
  const features = cylindoConfig()?.map?.features;
  if (features && Object.prototype.hasOwnProperty.call(features, key)) {
    return features[key];
  }
  return key.toUpperCase();
}
function cylindoOptionCode(featureCode, sku) {
  const mapped = cylindoConfig()?.map?.options?.[sku];
  if (!validOptions) return mapped || sku;
  const valid = validOptions[featureCode];
  if (!valid) return null;
  return [sku, mapped].find(
    (code) => code && valid.some((option) => option.code === code)
  ) || null;
}
function cylindoOptionCodeForValue(featureCode, value) {
  const valid = validOptions?.[featureCode];
  if (!valid || !value) return null;
  const wanted = value.toLowerCase();
  return valid.find((option) => option.code.toLowerCase() === wanted)?.code || valid.find((option) => option.name.toLowerCase() === wanted)?.code || null;
}
async function loadCylindoOptions() {
  const config = cylindoConfig();
  if (!config?.customerId || !config?.code) return null;
  const customer = encodeURIComponent(config.customerId);
  const code = encodeURIComponent(config.code);
  const url = `https://content.cylindo.com/api/v2/${customer}/products/${code}/configuration`;
  try {
    const response = await fetch(url);
    if (!response.ok) return null;
    const data = await response.json();
    const valid = {};
    (data.features || []).forEach((feature) => {
      valid[feature.code] = (feature.options || []).map((option) => ({
        code: option.code,
        name: option.name
      }));
    });
    validOptions = valid;
  } catch (err) {
  }
  return validOptions;
}
function updateCylindoViewer(features) {
  const config = cylindoConfig();
  if (!config) return;
  if (!features || Object.keys(features).length === 0) return;
  const viewers = document.querySelectorAll("cylindo-viewer");
  if (!viewers.length) return;
  const applyNowAndOnReady = (viewer) => {
    const apply = () => {
      viewer.features = { ...viewer.features, ...features };
    };
    apply();
    if (viewer.dataset.cylindoReady !== "true") {
      viewer.addEventListener("ready", apply, { once: true });
    }
  };
  const applyToAll = () => viewers.forEach(applyNowAndOnReady);
  if (window.customElements?.get("cylindo-viewer")) {
    applyToAll();
  } else {
    window.customElements?.whenDefined("cylindo-viewer").then(applyToAll);
  }
}

// src/scripts/cylindo-variants.js
var logger2 = new logger_default("Cylindo variants:");
function getFeaturesFromVariant(variant) {
  const features = {};
  if (!variant) return features;
  const config = cylindoConfig();
  const sku = variant.sku && !isLikelyVariantId(variant.sku) ? variant.sku : null;
  (config?.optionNames || []).forEach((name, index) => {
    const key = name.toLowerCase();
    const featureCode = cylindoFeatureCode(key);
    if (!featureCode) return;
    const value = variant[`option${index + 1}`];
    const mappedValue = config?.map?.values?.[key]?.[value];
    const code = sku && cylindoOptionCode(featureCode, sku) || cylindoOptionCodeForValue(featureCode, mappedValue || value);
    if (code) features[featureCode] = code;
  });
  return features;
}
function readProductJson(root, selector) {
  const el = root.querySelector(selector);
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (err) {
    logger2.error(`Failed to parse ${selector}`, err);
    return null;
  }
}
function init() {
  if (window.linkedProductSwitcher) {
    return;
  }
  const config = cylindoConfig();
  if (!config?.productId) return;
  const root = document.getElementById(config.viewerId)?.closest(".shopify-section") || document;
  const variants = readProductJson(root, '[data-product-json="variants"]') || [];
  if (!variants.length) return;
  let currentId = readProductJson(
    root,
    '[data-product-json="selected-variant"]'
  )?.id;
  let validated = false;
  let loading = null;
  const apply = () => {
    if (!validated) return;
    const variant = variants.find((item) => item.id === Number(currentId));
    updateCylindoViewer(getFeaturesFromVariant(variant));
  };
  const load = () => {
    if (loading) return;
    loading = loadCylindoOptions().then((valid) => {
      loading = null;
      validated = Boolean(valid);
      apply();
    });
  };
  document.addEventListener(
    `swanky:product${config.productId}:variant-changed`,
    (event) => {
      currentId = event.detail?.variantId;
      if (validated) apply();
      else load();
    }
  );
  load();
}
init();
